module.exports = __webpack_public_path__ + "img/menu3.84a60bd0.png";